let cacheInstances = {};

class StorageCache {
  constructor(key) {
    this.key = key;
    this.data = JSON.parse(localStorage.getItem(this.key));
    if (!this.data) {
      localStorage.setItem(this.key, JSON.stringify([]));
      this.data = JSON.parse(localStorage.getItem(this.key));
    }
  }
  get(name) {
    const entry = this.data.find((item) => item.name === name);
    if (!entry) return null;
    // if lifespan expired, delete the cache and return null
    if (Date.now() - entry.timestamp > entry.lifespan) {
      this.delete(name);
      return null;
    }
    // finally return the actual value
    return entry.value;
  }
  set(name, value, lifespan) {
    const entry = { name, value, timestamp: Date.now(), lifespan };
    const isExist = this.data.some((item) => item.name === entry.name);
    if (isExist) {
      // overriding the existing entry
      this.data = this.data.map((itm) => {
        return itm.name == entry.name ? entry : itm;
      });
    } else {
      this.data.push(entry);
    }
    localStorage.setItem(this.key, JSON.stringify(this.data));
  }
  delete(key) {
    this.data = this.data.filter((item) => item.name !== key);
    localStorage.setItem(this.key, JSON.stringify(this.data));
  }
}

export const useStorageCache = (name) => {
  let instance = cacheInstances[name];
  if (!instance && typeof localStorage !== "undefined") {
    instance = new StorageCache(name);
    cacheInstances[name] = instance;
  }
  return instance;
};
